<template>
  <v-icon
    v-on="$listeners"
    v-bind="$attrs"
    :title="displayedTitle"
    :color="displayedColor"
  >
    {{ displayedIcon }}
  </v-icon>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';

export default {
  name: 'BaseIcon',
  mixins: [
    LocaleUtils
  ],
  props: {
    value: {
      required: true
    },
    transformFunction: {
      type: Function,
      default() {
        return (value) => value;
      }
    },
    icon: {
      required: true,
    },
    color: {
      default() {
        return 'success';
      }
    },
    title: {
      default() {
        return '';
      }
    },
    translate: {
      type: Boolean,
      default() {return true;}
    }
  },
  data: () => ({
    defaultIconColor: '#BBB',
  }),
  computed: {
    transformedValue() {
      return this.transformFunction(this.value);
    },
    displayedIcon() {
      if(typeof this.icon === 'function') {
        return this.icon(this.transformedValue);
      }

      return this.icon;
    },
    displayedColor() {
      if(typeof this.color === 'function') {
        return this.color(this.transformedValue, this.defaultIconColor) || this.defaultIconColor;
      }

      return this.transformedValue ? this.color : this.defaultIconColor;
    },
    displayedTitle() {
      if(typeof this.title === 'function') {
        let titleValue = this.title(this.transformedValue);
        return this.translate ? this.trans(titleValue) : titleValue;
      }

      return this.title;
    }
  }
}
</script>

<style scoped>

</style>